import { useEffect, useState } from "react";
import "./Navbar.css";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "Projects", href: "#projects" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  const onNavClick = (href) => (e) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false);
  };

  return (
    <header className={`nav ${scrolled ? "nav--scrolled" : ""}`}>
    <div className="container nav__inner">
      <a className="nav__brand" href="#top" onClick={onNavClick("#top")}>
  <img className="nav__brandMark" src="/assets/logo.png" alt="" aria-hidden="true" />
  <span className="nav__brandText">R. Issouf Zabre</span>
</a>

  <nav className="nav__links" aria-label="Primary">
    {LINKS.map((l) => (
      <a
        key={l.href}
        className="nav__link"
        href={l.href}
        onClick={onNavClick(l.href)}
      >
        {l.label}
      </a>
    ))}

    {/* <a
      className="btn btn--primary nav__cta"
      href="#contact"
      onClick={onNavClick("#contact")}
    >
      Hire Me
    </a> */}
  </nav>

  <button
    className="nav__menuBtn"
    type="button"
    aria-label={open ? "Close menu" : "Open menu"}
    aria-expanded={open}
    onClick={() => setOpen((v) => !v)}
  >
    <span className="nav__menuIcon" aria-hidden="true" />
  </button>
</div>


      {open && (
        <div className="nav__mobile" role="dialog" aria-modal="true" aria-label="Menu">
          <button className="nav__backdrop" onClick={() => setOpen(false)} aria-label="Close menu" />
          <div className="nav__panel">
            <div className="nav__panelTop">
              <span className="nav__panelTitle">Menu</span>
              <button className="nav__closeBtn" onClick={() => setOpen(false)} aria-label="Close menu">
                ✕
              </button>
            </div>

            <div className="nav__panelLinks">
              {LINKS.map((l) => (
                <a key={l.href} className="nav__panelLink" href={l.href} onClick={onNavClick(l.href)}>
                  {l.label}
                </a>
              ))}
              {/* <a className="btn btn--primary" href="#contact" onClick={onNavClick("#contact")}>
                Hire Me
              </a> */}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
